import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './registerServiceWorker'
import "babel-polyfill"
import '@/utils/nativeJsBridge'
import delay from '@/utils/delay'
Vue.prototype.delay = delay

let moment = require("moment");
Vue.prototype.moment = moment;

//全局引入组件
import eleUi from '@/components/index.js';
Vue.use(eleUi);

//lodash
import _ from 'lodash'
Vue.prototype._ = _

//vantUI
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

//SmartStorage
import { SmartStorage, SmartRem } from 'smart-core-util';

SmartRem.install(document, window)
Vue.prototype.iStorage = SmartStorage;

//tiny-cookie
import * as tinyCookie from 'tiny-cookie';
Vue.prototype.$cookies = tinyCookie;

import { Toast } from 'vant';
Vue.prototype.$toast = Toast;

import iJsBridge from 'smart-javascript-bridge'
Vue.prototype.iJsBridge = new iJsBridge({ alert: Toast });

import validate from '@/utils/js/validate'
Vue.prototype.validate = validate

import SetUris from '@/utils/getUris.js';

// 组件通信
var bus = new Vue()
Vue.prototype.$bus = bus
Vue.config.productionTip = false

// 益普生参会人
import Mint from 'mint-ui';
Vue.use(Mint);
import 'mint-ui/lib/style.css'
import SmartModule from 'smart-module';
import 'smart-module/lib/index.css';
Vue.use(SmartModule);
import AppInitialization from "@/plugins/app-initialization.js"
import CacheData from "@/plugins/cache-data.js";
SetUris.install().then(() => {
  Promise.all([AppInitialization.install(),CacheData.install()]).then(() => {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  });
});
